import styles from '../../chatAssist.module.scss';
import classNames from 'classnames';
import ChatAssistV3Logic from './ChatAssistV3.logic';
import { ArrowDownward } from '@material-ui/icons';
import Loader from '../../Loader/Loader';
import { IntroducingKai, IntroducingNea, tipsTextKai, tipsTextNea } from '../../constants';
import PromptContainer from '../../PromptContainer/PromptContainer';
import ChatInput from '../../ChatInput/ChatInput';
import IconButton from '../../IconButton/IconButton';
import MessagesContainerWithFeedback from './MessageContainerWithFeedback/MessageContainerWithFeedback';

const ChatAssistV3 = ({ chatAgent }) => {
  const {
    conversation,
    messagesContainerRef,
    firstQuestionRef,
    firstResponseRef,
    value,
    showScrollButton,
    isWaiting,
    isJustSpaces,
    onChange,
    scrollToBottom,
    handleSendMessage,
    conversation_id,
    client_id,
    handleRegenerateResponse,
  } = ChatAssistV3Logic();
  
  return (
    <div className={styles.chatContainer}>
      <div
        className={classNames(styles.messagesContainer, {
          [styles.hidden]: Object.keys(conversation).length === 0,
        })}
        ref={messagesContainerRef}
      >
        <MessagesContainerWithFeedback
          isWaiting={isWaiting}
          handleRegenerateResponse={handleRegenerateResponse}
          clientId={client_id}
          conversationId={conversation_id}
          messages={conversation}
          firstQuestionRef={firstQuestionRef}
          firstResponseRef={firstResponseRef}
        />
      </div>
      {showScrollButton && (
        <button className={styles.scrollButton} onClick={scrollToBottom}>
          <ArrowDownward />
        </button>
      )}
      {conversation.length === 0 && (
        <div className={styles.introContainer}>
          <div className={styles.agentContainer}>
            <div>
              <p className={styles.title}>
                {chatAgent === 'Kai' ? '⚡ KAI — Sales Rep' : '🤖 Nea — SalesManager'} Co-Pilot
              </p>
              <p className={styles.text}>{chatAgent === 'Kai' ? IntroducingKai : IntroducingNea}</p>
            </div>
          </div>
          <div className={styles.promptContainer}>
            {chatAgent === 'Kai'
              ? tipsTextKai.map((item, index) => (
                  <PromptContainer
                    key={index}
                    title={item?.title}
                    text={item?.text}
                    image={item?.image}
                  />
                ))
              : tipsTextNea.map((item, index) => (
                  <PromptContainer
                    key={index}
                    title={item?.title}
                    text={item?.text}
                    image={item?.image}
                  />
                ))}
          </div>
        </div>
      )}
      {isWaiting && (
        <div className={styles.loadMessageContainer}>
          <Loader />
        </div>
      )}
      <div className={styles.inputContainer}>
        <ChatInput
          value={value}
          onChange={onChange}
          onKeyPress={handleSendMessage}
          disabled={isWaiting}
          placeholder={`${chatAgent} is your shortcut to SalesTable insights. Ask or search anything.`}
        />
        <IconButton
          onClick={handleSendMessage}
          disabled={isWaiting || value === '' || isJustSpaces(value)}
        />
      </div>
    </div>
  );
};

export default ChatAssistV3;
